import { render, staticRenderFns } from "./ConsultaTuCuentaForm.vue?vue&type=template&id=fab99500&scoped=true"
import script from "./ConsultaTuCuentaForm.vue?vue&type=script&lang=ts"
export * from "./ConsultaTuCuentaForm.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaTuCuentaForm.vue?vue&type=style&index=0&id=fab99500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab99500",
  null
  
)

export default component.exports